import { Icon } from "web/components"

const aOrAn = (word_after) => (/^[aeiou]/i.test(word_after) ? "an" : "a")

export default function EventDeleted({ event }) {
  return (
    <>
      <Icon name="minus-circle" outline="true" />{" "}
      <span>
        {`${event.creator} deleted ${aOrAn(
          event.recordable_type
        )} ${event.recordable_type.toLowerCase()}:`}
        &nbsp;
        <b>{event.recordable_name}</b>
      </span>
    </>
  )
}
